'use strict';

// eslint-disable-next-line no-multi-assign
window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

const isVviinnEnabled = $('body').data('vviinn-enabled');

$(document).ready(function () {
    if ('initialized' in window && window.initialized) return;

    if (isVviinnEnabled && !window.isVviinnSearchPage) {
        processInclude(require('./components/vviinnWidgets'));

        var $svgIcon = $('.site-search .vviinn-vps-button-icon');

        if ($svgIcon) {
            $svgIcon.attr('aria-label', 'Bild-/Fotosuche');
        }
    }

    processInclude(require('./components/stickyHeader'));
    processInclude(require('./components/menu'));
    processInclude(require('./components/usercentrics'));
    processInclude(require('./components/retailAds'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('base/components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./components/productDetailQuickView'));
    processInclude(require('wishlists/product/wishlistHeart'));
    processInclude(require('google_analytics/tracking/tracking'));
    processInclude(require('./components/vviinnAddToCart'));
    processInclude(require('./components/promoBanner'));
    processInclude(require('./carousel'));
    processInclude(require('./components/bannerPD'));
    processInclude(require('./components/scrollToTopButton'));

    new ResizeObserver(() => {
        const vh = window.innerHeight / 100;
        const vw = document.documentElement.clientWidth / 100;

        document.documentElement.style.setProperty('--vh', `${vh}px`);
        document.documentElement.style.setProperty('--vw', `${vw}px`);
    }).observe(document.documentElement);
});

require('base/thirdParty/bootstrap');
require('base/components/spinner');
